import { yellow } from "@mui/material/colors";

const AppColors = {
  purple: "#D3ABFF",
  purple01: "#DCB9FA",
  purple02: "#8C71B6",
  purple03: "rgba(191, 151, 255, 0.40)",
  darkPurple: "#743AFF",
  black: "#414141",
  black01: "#625E5E",
  darkBlack: "#000000",
  golden: "rgb(218, 181, 95, 0.4)",
  golden01: "#DAB55F",
  green: "#29CA41",
  green01: "#EDF8EE",
  green02: "#ECF7EC",
  green03: "#266a22",
  green09: "#6fb26b",
  darkGreen: "#3B6B44",
  brown: "#EE9938",
  brown01: "#FBF1E6",
  darkBrown: "#945711",
  red: "#C94930",
  red01: "rgb(221 35 0 / 16%)",
  darkRed: "#632418",
  yellow: "#fee1bf",
  yellow01: "#F4EE5A",
  yellow04: "#f5e591",
  orange: "#fcbaa9",
  white: "#fff",
  cyan: "#6FACB0",
  cyan01: "rgba(101, 191, 196, 0.40)",
};

export default AppColors;
